import { Button, Col, Grid, Row, Typography } from "antd"
import { ContactModal } from "../ContactModal/web"
import { FinancingInput } from "../FinancingInput/FinancingInput"
import { formatMoney } from "@Utils/Functions"
import { ImagenOptimizada } from "../../Image/web"
import { Input, InputWithPercentage, Select } from "../dataInputs"
import { useBBVAFinancing } from "./hook"
import { useState } from "react"
import { useTheme } from "../../../Styles/ThemeHook"
import "./styles.less"

const { useBreakpoint } = Grid;

const DESKTOP_SOURCE = 0;
const MOBILE_SOURCE = 4;

const LEAD_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/bbva/sendForm";

export const BBVAFinancing = ({
	id,
	isDisabledProperty = false,
	showFinancingCard = false,
	financingRef = null,
	price=0,
}) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const screen = useBreakpoint();
	const source = screen.lg ? DESKTOP_SOURCE : MOBILE_SOURCE;
	const {
		loan: { amount: loan, change: setLoan },
		property: { amount: propertyPrice },
		income: { amount: income, change: setIncome },
		years: { value: years, change: setYears, totalYears },
		currency: { value: currency, change: setCurrency, options: currencies },
		type: { value: type, change: setType, options: types },
		asset: { value: asset, change: setAsset, options: assets },
		payment,
		error,
		fixError,
		extraData,
		show,
		bbvaService,
	} = useBBVAFinancing({ id, source, propertyPrice: price });
	const { theme } = useTheme();
	const [modal, setModal] = useState(false);

	const onScrollToFinancing = () => {
		if (financingRef) {
			const componentFinancing = financingRef.current.offsetTop;
			const withAffixHeight = screen.lg ? 30 : 0;
			const scrollingTo = componentFinancing + withAffixHeight;
			window.scrollTo({ top: scrollingTo, behavior: "smooth" });
		}
	};

	const handleIncomeChange = (value, type) => {
		if (type === "plus") setIncome(value + 1);
		else if (type === "minus") setIncome(value - 1);
		else setIncome(value)
	}

	const handleLoanChange = (value, type) => {
		if (type === "plus") setLoan(value + 1);
		else if (type === "minus") setLoan(value - 1);
		else setLoan(value)
	}

	if (!show) return null;

	if (showFinancingCard) {
		return (
			<div className="property-financing-BBVA-card">
				<div className="bbva-header">
					Compra esta propiedad pagando <b>U$S {formatMoney(propertyPrice - loan)}</b> y
					cuotas de <b>$ {payment}</b>
				</div>
				<div className="bbva-footer">
					<div className="bbva-logo">
						<ImagenOptimizada
							src="https://cdn4.fincaraiz.com.co/web/5d496d2a66e91_infocdn__landing-bbva_uy-07-min.png"
							alt="BBVA"
						/>
						<span>Creando Oportunidades</span>
					</div>
					<Button onClick={onScrollToFinancing} className="bbva-btn"> Ver más </Button>
				</div>
			</div>
		);
	}
	
	return (
		<div className="property-financing-BBVA">
			<Row gutter={[0, theme.spacing.mdSpacing]}>
				<Col span={24}>
					<Typography.Title level={4}>Financiación</Typography.Title>
				</Col>
				<Col xs={24} md={16}>
					<div className="property-financing-box">
						<div className="bbva-logo">
							<ImagenOptimizada
								src="https://cdn4.fincaraiz.com.co/web/5d496d2a66e91_infocdn__landing-bbva_uy-07-min.png"
								alt="BBVA"
							/>
							<span>Creando Oportunidades</span>
						</div>
						<Row gutter={[theme.spacing.xxlSpacing, theme.spacing.mdSpacing]}>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Importe a Solicitar"
									input={
										<InputWithPercentage
											isDisabledProperty={isDisabledProperty}
											value={loan}
											max={propertyPrice}
											onChange={(value, type) => handleLoanChange(value, type)}
											percentage={Math.round((loan * 100) / propertyPrice)}
											currency="U$S"
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Ingresos Mensuales"
									input={
										<Input
											isDisabledProperty={isDisabledProperty}
											value={income}
											onChange={(value, type) => handleIncomeChange(value, type)}
											currency="$"
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Moneda del Préstamo"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={currency}
											options={currencies}
											onChange={setCurrency}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Plazo"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={years}
											options={totalYears}
											onChange={setYears}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Tipo de Vivienda"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={type}
											options={types}
											onChange={setType}
										/>
									}
									fullWidth
								/>
							</Col>
							<Col xs={24} md={12}>
								<FinancingInput
									title="Cobro Haberes en BBVA"
									input={
										<Select
											isDisabledProperty={isDisabledProperty}
											value={asset}
											options={assets}
											onChange={setAsset}
										/>
									}
									fullWidth
								/>
							</Col>
						</Row>
					</div>
				</Col>
				<Col xs={24} md={8} className="property-financing-monthly">
					{payment ? (
						<>
							<Typography.Title>Tu cuota mensual:</Typography.Title>
							<Typography.Title className="financing-price">
								$ {payment}
							</Typography.Title>
							<Button
								disabled={isDisabledProperty}
								className="bbva-financing-button"
								onClick={() => setModal(true)}>
								Obtener más información
							</Button>
						</>
					) : null}
					{error ? (
						<div className="financing-error">
							<Typography.Paragraph>
								<div dangerouslySetInnerHTML={{ __html: error }} />
								<span onClick={fixError} className="financing-error-fix">
									Corregir y volver a calcular.
								</span>
							</Typography.Paragraph>
						</div>
					) : null}
				</Col>
			</Row>
			<ContactModal
				sendLeadURL={LEAD_SERVICE}
				extraData={extraData}
				source={source}
				beforeSubmitForm={async () => {
					return await bbvaService(false);
				}}
				onSuccess={() => {
					setModal(false);
					handleClickShowNotification({
						message: "¡Gracias por tu consulta!",
						description: "Tus datos han sido enviados con éxito. En las próximas horas nos contactaremos contigo para darte más información.",
					});
				}}
				title="Calcular cuota de préstamo"
				topText="Completa estos datos para recibir más información"
				visible={modal}
				closeModal={() => setModal(false)}
			/>
		</div>
	);
};
